import React, { useState, useEffect } from "react";
import { Table, Button, Form, Container, Row, Col } from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./AccessTable.css";
import axios from "axios";
import Swal from "sweetalert2";
import { useDispatch } from 'react-redux';
import { setRolePermissions } from "../Redux/actions"; // update path if needed


// Titles and configurations
const titles = [
  "Side Bar",
  "Dashboard",
  "Task",
  "Enquiry",
  "Installation",
  "Complaint",
  "Recovery",
  "Due",
  "Stock",
  "Customer",
  "Staff",
  "Staff Analysis",
  "Attendance",
  "Location",
  "Administration",
  "Settings",
];



// Modules structure with initial permissions

// Define which permissions should be shown for each title
const permissionsVisibility = {
  "Side Bar": ["Read", "Write"],
  Dashboard: ["Read", "Delete"],
  Task: ["Read", "Write", "Delete"],
  Enquiry: ["Read", "Write", "Delete"],
  Installation: ["Read", "Write", "Delete"],
  Complaint: ["Read", "Write", "Delete"],
  Recovery: ["Read", "Write", "Delete"],
  Due: ["Read", "Write", "Delete"],
  Stock: ["Read", "Write", "Delete"],
  Customer: ["Read", "Write", "Delete"],
  Staff: ["Read", "Write", "Delete"],
  "Staff Analysis": ["Read", "Write"],
  Attendance: ["Read", "Write", "Delete"],
  Location: ["Read", "Write", "Delete"],
  Administration: ["Read", "Write", "Delete"],
  Settings: ["Read", "Write", "Delete"],
};

const AccessTable = (props) => {
  const [initialPermissions, setinitialPermissions] = useState({
    "Side Bar": {
      Dashboard: { Read: false, Write: false },
      Task: { Read: false, Write: false },
      Enquiry: { Read: false, Write: false },
      "Task Create": { Read: false, Write: false },
      Installation: { Read: false, Write: false },
      Complaints: { Read: false, Write: false },
      Dues: { Read: false, Write: false },
      Stock: { Read: false, Write: false },
      "Stock Details": { Read: false, Write: false },
      Recovery: { Read: false, Write: false },
      "Customer Reports": { Read: false, Write: false },
      "Staff Analysis": { Read: false, Write: false },
      Attendance: { Read: false, Write: false },
      Location: { Read: false, Write: false },
      Staffs: { Read: false, Write: false },
      Customers: { Read: false, Write: false },
      Administration: { Read: false, Write: false },
      Settings: { Read: false, Write: false },
    },
    Dashboard: {
      "Show all Statistics": { Read: false },
      "Show Installation Statistics": { Read: false },
      "Show Complaint Statistics": { Read: false },
      "Show Task Statistics": { Read: false },
      "Show Recovery Statistics": { Read: false },
      "Show Dues Statistics": { Read: false },
      "Show Enquiry Chart": { Read: false },
      "Show Installation Chart": { Read: false },
      "Show Complaint Chart": { Read: false },
      "Show Task Chart": { Read: false },
      "Show Recovery Chart": { Read: false },
      "Show Dues Chart": { Read: false },
      "General Updates": { Read: false, Delete: false },
      "Enquiry Updates": { Read: false, Delete: false },
      "Installation Updates": { Read: false, Delete: false },
      "Complaint Updates": { Read: false, Delete: false },
      "Recovery Updates": { Read: false, Delete: false },
      "Due Updates": { Read: false, Delete: false },
    },
    Task: {
      "Task Statistics": { Read: false },
      "Task Module": { Read: false, Write: false, Delete: false },
      "Map View": { Read: false, Write: false },
      "Task Create": { Read: false, Write: false },
      "Edit Task": {  Write: false, },

      "Enquiry Task Assign": { Read: false, Write: false },
      "Installation Task Assign": { Read: false, Write: false },
      "Complaint Task Assign": { Read: false, Write: false },
      "Recovery Task Assign": { Read: false, Write: false },
      "Due Task Assign": { Read: false, Write: false },
      "General Task": { Read: false, Write: false, Delete: false },
      "Enquiry Task": { Read: false, Write: false, Delete: false },
      "Installation Task": { Read: false, Write: false, Delete: false },
      "Complaint Task": { Read: false, Write: false, Delete: false },
      "Recovery Task": { Read: false, Write: false, Delete: false },
      "Due Task": { Read: false, Write: false, Delete: false },
      "General Task Update": { Read: false, Write: false, Delete: false },
      "Enquiry Update": { Read: false, Write: false, Delete: false },
      "Installation Update": { Read: false, Write: false, Delete: false },
      "Complaint Update": { Read: false, Write: false, Delete: false },
      "Recovery Update": { Read: false, Write: false, Delete: false },
      "Due Update": { Read: false, Write: false, Delete: false },
      "General Task Approval": { Read: false, Write: false, Delete: false },
    },
    Enquiry: {
      "Enquiry Statistics": { Read: false },
      "Enquiry Module": { Read: false, Write: false, Delete: false },
      "Map View": { Read: false, Write: false },
      "Add Enquiry": { Read: false, Write: false, Delete: false },
      "Enquiry Task Assign": { Read: false, Write: false },
      "Enquiry Updates": { Read: false, Write: false, Delete: false },
      "Enquiry Task Approve": { Read: false, Write: false },
    },
    Installation: {
      "Installation Statistics": { Read: false },
      "Installation Module": { Read: false, Write: false, Delete: false },
      "Map View": { Read: false, Write: false },
      "Add Installation": { Read: false, Write: false },
      "Installation Verification": { Read: false, Write: false },
      "Installation Task Assign": { Read: false, Write: false },
      "Installation Updates": { Read: false, Write: false, Delete: false },
      "Installation Task Approve": {
        Read: false,
        Write: false,
        Delete: false,
      },
      "Work Details": { Read: false, Write: false, Delete: false },
      Feedback: { Read: false, Write: false },
      Payment: { Read: false, Write: false },
    },
    Complaint: {
      "Complaint Statistics": { Read: false },
      "Complaint Module": { Read: false, Write: false, Delete: false },
      "Map View": { Read: false, Write: false },
      "Add Complaint": { Read: false, Write: false },
      "Complaint Verification": { Read: false, Write: false },
      "Complaint Task Assign": { Read: false, Write: false },
      "Complaint Updates": { Read: false, Write: false, Delete: false },
      "Complaint Task Approve": { Read: false, Write: false, Delete: false },
      "Work Details": { Read: false, Write: false, Delete: false },
      Feedback: { Read: false, Write: false },
      Payment: { Read: false, Write: false },
    },
    Recovery: {
      "Recovery Statistics": { Read: false },
      "Recovery Module": { Read: false, Write: false, Delete: false },
      "Map view": { Read: false, Write: false },
      "Add Recovery": { Read: false, Write: false },
      "Recovery Task Assign": { Read: false, Write: false },
      "Recovery Updates": { Read: false, Write: false, Delete: false },
      "Recovery Task Approve": { Read: false, Write: false, Delete: false },
    },
    Due: {
      "Due Statistics": { Read: false },
      "Due Module": { Read: false, Write: false, Delete: false },
      "Map view": { Read: false, Write: false },
      "Add Dues": { Read: false, Write: false },
      "Due Task Assign": { Read: false, Write: false },
      "Due Updates": { Read: false, Write: false, Delete: false },
      "Due Task Approve": { Read: false, Write: false, Delete: false },
    },
    Stock: {
      "Stock Statistics": { Read: false },
      "Stock Module": { Read: false, Write: false, Delete: false },
      "Add Stock": { Read: false, Write: false },
    },
    Customer: {
      "Customer Statistics": { Read: false },
      "Customer Module": { Read: false, Write: false, Delete: false },
      "Add Customer": { Read: false, Write: false },
    },
    Staff: {
      "Staff Details": { Read: false, Write: false, Delete: false },
      "Staff Module": { Read: false, Write: false, Delete: false },
      "Add Staff": { Read: false, Write: false },
    },
    "Staff Analysis": {
      "Staff Analysis Details": { Read: false, Write: false },
    },
    Attendance: {
      "Attendance Statistics": { Read: false },
      "Attendance Module": { Read: false, Write: false, Delete: false },
      "Mark Attendance": { Read: false, Write: false },
    },
    Location: {
      "Location Statistics": { Read: false },
      "Location Module": { Read: false, Write: false, Delete: false },
      "Map View": { Read: false, Write: false },
    },
    Administration: {
      Permission: { Read: false, Write: false, Delete: false },
      "Add Roles": { Read: false, Write: false, Delete: false },
    },
    Settings: {
      "Ott Details": { Read: false, Write: false, Delete: false },
      "Lead Sources": { Read: false, Write: false, Delete: false },
    },
  });
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [currentPage, setCurrentPage] = useState(0);
  const [permissions, setPermissions] = useState(initialPermissions);

  const currentTitle = titles[currentPage];
  const currentModules = permissions[currentTitle];
  const visiblePermissions = permissionsVisibility[currentTitle];
  const dispatch = useDispatch();


  console.log("initialPermissions", initialPermissions);
  console.log("permissions", permissions);
  console.log("currentTitle", currentTitle);
  console.log("currentModules", currentModules);

  // Get module names for current title
  const moduleNames = Object?.keys(currentModules);

  const isAllChecked = () => {
    let isCheck = true;
    visiblePermissions.forEach((visibiity) => {
      if (!isGlobalChecked(visibiity)) return (isCheck = false);
    });

    return isCheck;
  };

  // const isAllChecked = moduleNames.every(moduleName => {
  //   visiblePermissions.every(perm => currentModules[moduleName][perm])
  // });

  // Check if a specific permission is selected for all modules
  const isGlobalChecked = (permissionType) => {
    let defaultValue = [];
    moduleNames.forEach((moduleName) => {
      if (
        JSON.stringify(currentModules[moduleName])?.includes(permissionType)
      ) {
        defaultValue.push(moduleName);
      }
    });
    return defaultValue?.every(
      (moduleName) => currentModules[moduleName][permissionType]
    );
  };

  // Handle individual permission change
  const [selectedPermission, setSelectedPermission] = useState({
    moduleName: "",
    permissionType: "",
    checked: false,
  });

  const handleModulePermissionChange = async (moduleName, permissionType) => {
    setPermissions((prev) => ({
      ...prev, // Preserve other titles
      [currentTitle]: {
        ...prev[currentTitle], // Preserve other modules under the title
        [moduleName]: {
          ...prev[currentTitle]?.[moduleName], // Preserve other permissions of the module
          [permissionType]: !prev[currentTitle]?.[moduleName]?.[permissionType], // Toggle permission
        },
      },
    }));

    // Get the new checked status
    const newCheckedState =
      !permissions[currentTitle]?.[moduleName]?.[permissionType];

    // Update selectedPermission state
    setSelectedPermission({
      moduleName,
      permissionType,
      checked: newCheckedState,
    });

    // Simulate API update (replace with actual DB update function)
    updatePermissionInDB({
      ...permissions, // Spread existing permissions
      [currentTitle]: {
        ...permissions[currentTitle], // Spread other modules under the same title
        [moduleName]: {
          ...permissions[currentTitle]?.[moduleName], // Spread other permissions of the module
          [permissionType]: newCheckedState, // Update specific permission
        },
      },
    });
  };

  // Mock function to update permissions in the database
  const updatePermissionInDB = (updatedPermissions) => {
    console.log("Updating DB with permissions:", updatedPermissions);
    console.log("roles", props.roles);
    // Perform actual DB update call here
  };

  // Handle all permissions toggle
  const handleAllPermissionChange = () => {
    const newState = !moduleNames.every((moduleName) =>
      Object.values(currentModules[moduleName]).every((perm) => perm)
    );
    const updatedModules = { ...currentModules };
    moduleNames.forEach((moduleName) => {
      Object.keys(updatedModules[moduleName]).forEach((perm) => {
        updatedModules[moduleName][perm] = newState;
      });
    });
    setPermissions((prev) => ({
      ...prev,
      [currentTitle]: updatedModules,
    }));
  };

  // Handle global permission column toggle
  const handleGlobalPermissionChange = (permissionType) => {
    const newState = !isGlobalChecked(permissionType);
    const updatedModules = { ...currentModules };
    moduleNames.forEach((moduleName) => {
      if (
        JSON.stringify(updatedModules[moduleName])?.includes(permissionType)
      ) {
        updatedModules[moduleName][permissionType] = newState;
      }
    });

    setPermissions((prev) => ({
      ...prev,
      [currentTitle]: updatedModules,
    }));
  };

  const handleNext = () =>
    currentPage < titles.length - 1 && setCurrentPage((p) => p + 1);
  const handlePrev = () => currentPage > 0 && setCurrentPage((p) => p - 1);

  const filteredModuleNames = moduleNames.filter((moduleName) =>
    visiblePermissions.some((perm) =>
      currentModules[moduleName].hasOwnProperty(perm)
    )
  );

  //Save
  // const savePermissions = async () => {
  //   try {
  //     const payload = {
  //       roles: props.roles, // Include the role from props
  //       // moduleName: selectedPermission.moduleName, // Include the selected module name
  //       permissions: permissions // Include the entire permissions object
  //     };
  //     await axios.post("http://localhost:5000/api/add", payload);
  //     alert("Permissions saved successfully!");
  //   } catch (error) {
  //     console.error("Error saving permissions:", error);
  //     alert("Failed to save permissions.");
  //   }
  // };

  const fetchPermissions = async () => {
    try {
      const response = await axios.post(
        apiUrl + "adminview",
        { roleName: props.roles },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.data.message === "Admin role not found") {
        console.log("Admin role not found");
        // setError("Role not found. Default permissions loaded.");
      } else {
        setinitialPermissions(response.data.message.modules);
        setPermissions(response.data.message.modules);
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

const savePermissions = async () => {
  try {
    const payload = {
      roleName: props.roles,
      modules: permissions,
    };

    const response = await axios.post(apiUrl + "adminadd", payload, {
      headers: { "Content-Type": "application/json" },
    });

    // ✅ Dispatch the response data to Redux
    

    Swal.fire({
      title: "Permissions saved successfully!",
      icon: "success",
      draggable: true,
    });
  } catch (error) {
    console.error(
      "Error saving permissions:",
      error.response?.data || error.message
    );
    alert("Failed to save permissions.");
  }
};


  useEffect(() => {
    fetchPermissions();
  }, []);

  return (
    <Container fluid className="fullcomponent">
      <div className="border-header-admin">

      <h5 className="roles-top1 text-center">{props.roles}</h5>

      </div>
      <button onClick={savePermissions} className="blue-btn admin-submit">
        Submit
      </button>
      <div className="tableborder-admin">

        <table style={{ width: "100%", backgroundColor: "white", borderBottom: "2px" }} className="table-admin ">
          <thead style={{backgroundColor:"white"}} >
            <tr style={{backgroundColor:"white"}} >
              <th className="accesstable-th-fontsize">

                <Row>
                  <Col md={8} sm={8} xs={8}>
                    <Row>
                      <Row className="taskrow">
                        <Col md={5} sm={5} xs={5}>
                          <h5 style={{ paddingTop: "15px" }}>{currentTitle}</h5>
                        </Col>
                        <Col>
                          <Row style={{}}>

                            <Col md={2} sm={2} xs={2} >
                              <Button style={{ paddingTop: "10px", paddingLeft: "-10px" }} variant="link" className="arrow-button" onClick={handlePrev} disabled={currentPage === 0}>
                                <FaChevronLeft />
                              </Button>
                            </Col>
                            <Col style={{ paddingTop: "8px", paddingLeft: "30px", }} md={2} sm={2} xs={2}>
                              <p >{currentPage + 1}</p>
                            </Col>
                            <Col style={{ paddingTop: "5px", }} md={2} sm={2} xs={2}>
                              <Button variant="link" className="arrow-button" onClick={handleNext} disabled={currentPage === titles.length - 1}>

                                <FaChevronRight />
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Row>
                  </Col>
                  <Col style={{  }} md={4} sm={4} xs={4}>
                    <Form.Check
                      type="checkbox"
                      label="All"
                      checked={isAllChecked()}

                      
                      className="checkbox-label accesstable all-accesstable accesstable-th-fontsize"

                      onChange={handleAllPermissionChange}
                    />
                  </Col>
                </Row>
              </th>
              {/*             
            {visiblePermissions.map(perm => (
              <th key={perm} className="col-1">{perm}</th>
            ))} */}

              {visiblePermissions.map(perm =>
                <th  key={perm} className="text-center accesstable-th-fontsize">
                  
                  <Form.Check
                    type="checkbox"
                    label={perm}
                    checked={isGlobalChecked(perm)}
                    className="checkboxadmin accesstable"
                    onChange={() => handleGlobalPermissionChange(perm)}
                  />

                </th>
              )}
            </tr>
         </thead>

          <tbody >

          
            {filteredModuleNames.map(moduleName => (
              <tr key={moduleName}>
                <td className="accesstable-font-size">{moduleName}</td>
                {visiblePermissions.map(perm => (
                  <td key={perm}>
                    {
                      currentModules[moduleName].hasOwnProperty(perm) ? (
                        <Form.Check
                          type="checkbox"
                          checked={currentModules[moduleName][perm]}
                          onChange={() => handleModulePermissionChange(moduleName, perm)}
                          className="accesstable1"
                        />
                      ) : null}

                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Container>
  );
};

export default AccessTable;
